import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { logErrorAndRunFail, paramCheck } from '../utils';

export interface CapsuleStyleOption extends Partial<GeneralInvokeOption> {
  style: number;
  invalidParamObj?: '';
}

//  设置胶囊样式,style 0：黑色，1：白色
export function capsuleStyle(option: CapsuleStyleOption) {
  if (paramCheck(APINames.Native.CAPSULE_STYLE, option, { style: 0 })) {
    const validStyle: Array<number> = [0, 1];
    if (validStyle.indexOf(option.style) === -1) {
      return logErrorAndRunFail(
        APINames.Native.CAPSULE_STYLE,
        option,
        `parameter error: invalid style ${option.style}`
      );
    }
    return MacleJSBridge.beforeInvoke(APINames.Native.CAPSULE_STYLE, option);
  }
  return option.invalidParamObj;
}
